module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Box-3c7d1b3a104254c1d384dc6f8b633b27.svg";